<template>
  <div class="user-users_uus" :class="{ [curTheme]: true }">

    <page-header>
      <nav-inner :use-user-links="true"/>
    </page-header>
    <router-link
      class="help-link help-link_pcr"
      :to="{ path: '/help/20'}"
      target="_blank">
      Подробнее о моих контактах в разделе Помощь
    </router-link>

    <div class="page-container_pcr">

      <template v-if="bmarksData !== null">
        <template v-if="bmarksData.length > 0">
          <div
            v-for="(o, i) in bmarksData"
            :key="`lix-${i}`" class="fo_li">
            <router-link
              :key="o.objectId"
              class="uus_item"
              :to="`/user/${o.UserId}/profile/view`">
              <img v-if="avatarUrls && avatarUrls[o.UserId] !== ''"
                :src="avatarUrl(avatarUrls[o.UserId])" class="uus_img">
              <div class="uus_item-info">
                <div class="uus_fio">{{ fio(o) }}</div>
                <div class="uus_job">{{ job(o) }}</div>
                <div class="uus_more">{{ more(o) }}</div>
              </div>
            </router-link>
          </div>
        </template>
        <template v-else>
          <div class="no-results">
            <div
              class="depo-msg_dmg dmg_themable">
              <div class="dmg_user"></div>
              <div class="dmg_text">Ваш список контактов пуст. Вы можете добавить
                пользователей в этот список на странице их профилей.</div>
            </div>
          </div>
        </template>
      </template>

    </div>

    <page-footer/>

  </div>
</template>

<script>
import axios from 'axios';
import PageHeader from '../PageHeader';
import PageFooter from '../PageFooter';
import NavInner from '../NavInner';

export default {

  components: { PageHeader, PageFooter, NavInner },

  data() {
    return {
      bmarksData: null,
      avatarUrls: null,
    };
  },

  created() {
    const curUserId = this.$store.getters['user/getUserId'];
    axios.get(`bookmarks/${curUserId}?entityType=User`).then((r) => {
      this.bmarksData = r.data;
      const params = { user_id: [] };
      this.bmarksData.forEach((userData) => {
        params.user_id.push(userData.UserId);
      });
      if (params.user_id.length > 0) {
        axios.get('users/avatars', { params }).then((rAva) => {
          this.avatarUrls = rAva.data;
        });
      }
    }).catch(() => {
      this.$notify.error('Ошибка при получении избранных пользователей.');
    });
  },

  methods: {

    avatarUrl(url) {
      return url && url.length > 0 ?
        `${this.$store.state.apiUrl}${url}` : '/static/grx/no-image.png';
    },

    fio(user) {
      const fio = [];
      if (user.Surname) fio.push(user.Surname);
      if (user.Name) fio.push(user.Name);
      if (user.Patronymic) fio.push(user.Patronymic);
      return fio.join(' ');
    },

    job(user) {
      const job = [];
      if (user && Array.isArray(user.Jobs) && user.Jobs.length > 0) {
        if (user.Jobs[0].Organization) {
          job.push(user.Jobs[0].Organization);
        }
        if (user.Jobs[0].Department) {
          job.push(user.Jobs[0].Department);
        }
        if (user.Jobs[0].Post) {
          job.push(user.Jobs[0].Post);
        }
      }
      return job.join(', ');
    },

    more(user) {
      const more = [];
      if (user.AcademicTitle) more.push(user.AcademicTitle);
      if (user.AcademicDegree) more.push(user.AcademicDegree.join(', '));
      return more.join(' ');
    },

  },

};
</script>

<style lang="scss">
@import "../../styles/common/main";

.user-users_uus {
  .uus_item {
    padding: 25px;
    @include border-radius(7px);
    background: rgba(125, 125, 125, .2);
    margin: 30px 0;
    display: block;
    text-align: left;
    @include transition;
    @include clearfix;
    &:hover {
      background: rgba(125, 125, 125, .3);
    }
    @media (max-width: 500px) {
      padding: 15px;
    }
    .uus_img {
      -webkit-mask-image: url(../../../static/grx/hexagon-white.svg);
      mask-image: url(../../../static/grx/hexagon-white.svg);
      width: 100px;
      height: auto;
      float: left;
      margin: 0 25px 0 0;
      @media (max-width: 500px) {
        width: 120px;
        margin: 0 auto 17px;
        display: block;
        float: none;
      }
    }
    .uus_fio,
    .uus_job {
      margin-bottom: 10px;
    }
    .uus_item-info {
      overflow: hidden;
      display: block;
    }
    .uus_fio {
      font-size: 20px;
      line-height: 25px;
      font-weight: bold;
    }
    .uus_more {
      opacity: .6;
    }
  }
  &.theme-w {
    .uus_item {
      background: rgba(125, 125, 125, .1);
      &:hover {
        background: rgba(125, 125, 125, .2);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layouts/UserUsers.vue